module.exports = __webpack_public_path__ + "img/image12.5ffa2c4e.png";